module.exports = __webpack_public_path__ + "static/img/アセット 34@2x.b5fc407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 34@2x.png
// module id = AfDx
// module chunks = 1